import { createActions } from 'redux-actions'

export const constants = {
  UPDATE_RETURN_CALL_FORM_FIELD: 'UPDATE_RETURN_CALL_FORM_FIELD',
  GET_RETURN_CALLS: 'GET_RETURN_CALLS',
  RETRIEVE_RETURN_CALL: 'RETRIEVE_RETURN_CALL',
  RESOLVE_RETURN_CALL: 'RESOLVE_RETURN_CALL',
  DELETE_RETURN_CALL: 'DELETE_RETURN_CALL'
}

export const actions = createActions({
  GET_RETURN_CALLS: {
    REQUEST: () => ({}),
    SUCCESS: result => result,
    FAILURE: result => result
  },
  RETRIEVE_RETURN_CALL: {
    REQUEST: ({ callReportId }) => ({ callReportId }),
    SUCCESS: success => success,
    FAILURE: error => error
  },
  RESOLVE_RETURN_CALL: {
    REQUEST: ({ callReportId }) => ({ callReportId }),
    SUCCESS: success => success,
    FAILURE: error => error
  },
  DELETE_RETURN_CALL: {
    REQUEST: ({ callReportId, userId }) => ({ callReportId, userId }),
    SUCCESS: success => success,
    FAILURE: error => error
  },
})
